import * as moment from "moment";
import * as _ from "lodash";
import {
  FeeCalculationType,
  FeeCalculationStatus,
} from "../../../common/enums/FeeCalculation";
import { FeesRepo } from "../../fees.repo";

class TempRunController {
  // filter options
  public fromDate;
  public toDate;
  public searchFiltersList;
  public endOfLastMonth;
  public currentDate;
  public lastTwelveMonths;

  // Calculation Type
  public displayMCB: boolean = true;

  public selectedCurrency = "MUR";

  // fee data
  public clientFeeParameters;

  public selectAll: boolean = false;

  public isLoadingParameters: boolean = false;
  public isSavingParameters: boolean = false;

  public reloadTempParameters: boolean = false;

  public threshold: number = 10;

  // stats

  public totalNav: number = 0;

  public totalFeeValue: number = 0;

  public totalPortfolios: number = 0;

  public midRates: Array<any>;

  public midRateDate;

  /** @ngInject */
  constructor(
    private notifyjs,
    private feesRepo: FeesRepo,
    private $window: angular.IWindowService
  ) {
    var date = new Date();
    this.currentDate = date;

    this.endOfLastMonth = moment(date).subtract(1, "months").endOf("month");
    this.lastTwelveMonths = new Date(
      moment(date).subtract(18, "months").endOf("month").format("YYYY-MM-DD")
    );

    this.searchFiltersList = [
      {
        name: "Last Month",
        fromDate: moment(date)
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD"),
        toDate: moment(date)
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD"),
        active: false,
      },
      {
        name: "Last Quarter",
        fromDate: moment()
          .subtract(1, "Q")
          .startOf("quarter")
          .format("YYYY-MM-DD"),
        toDate: moment().subtract(1, "Q").endOf("quarter").format("YYYY-MM-DD"),
        active: false,
      },
      {
        name: "First Quarter",
        fromDate: moment().quarter(1).startOf("quarter").format("YYYY-MM-DD"),
        toDate: moment().quarter(1).endOf("quarter").format("YYYY-MM-DD"),
        active: false,
      },
      {
        name: "Second Quarter",
        fromDate: moment().quarter(2).startOf("quarter").format("YYYY-MM-DD"),
        toDate: moment().quarter(2).endOf("quarter").format("YYYY-MM-DD"),
        active: false,
      },
      {
        name: "Third Quarter",
        fromDate: moment().quarter(3).startOf("quarter").format("YYYY-MM-DD"),
        toDate: moment().quarter(3).endOf("quarter").format("YYYY-MM-DD"),
        active: false,
      },
      {
        name: "Fourth Quarter",
        fromDate: moment().quarter(4).startOf("quarter").format("YYYY-MM-DD"),
        toDate: moment().quarter(4).endOf("quarter").format("YYYY-MM-DD"),
        active: false,
      },
      {
        name: "Last 12 Months",
        fromDate: moment(date)
          .subtract(12, "months")
          .endOf("month")
          .format("YYYY-MM-DD"),
        toDate: moment().add(-1, "days").format("YYYY-MM-DD"),
        active: false,
      },
    ];

    if (_.isEmpty(this.fromDate) || _.isEmpty(this.toDate)) {
      this.fromDate = new Date(this.searchFiltersList[0].fromDate);
      this.toDate = new Date(this.searchFiltersList[0].toDate);
      this.searchFiltersList[0].active = true;
      this.getNewInstructionsParameters();
      this.midRateDate = new Date(this.searchFiltersList[0].toDate);
      this.getMidRateForMonth();
    }
  }

  $onChanges(changes) {
    if (changes.reloadTempParameters.currentValue) {
      this.getNewInstructionsParameters();
    }
  }

  filterFeeParameters = (filter) => {
    _.forEach(this.searchFiltersList, (filterOption) => {
      if (filterOption.name !== filter.name) {
        filterOption.active = false;
      }
    });
    filter.active = true;
    this.fromDate = new Date(filter.fromDate);
    this.toDate = new Date(filter.toDate);
    this.getNewInstructionsParameters();
  };

  toDateChanged = () => {
    _.forEach(this.searchFiltersList, (filterOption) => {
      filterOption.active = false;
    });
    this.getNewInstructionsParameters();
  };

  fromDateChanged = () => {
    if (this.fromDate < this.toDate) {
      _.forEach(this.searchFiltersList, (filterOption) => {
        filterOption.active = false;
      });
      this.getNewInstructionsParameters();
    }
  };

  getNewInstructionsParameters = () => {
    let feeCalculationType = this.displayMCB
      ? FeeCalculationType.MCB
      : FeeCalculationType.EDR;
    this.isLoadingParameters = true;
    let fromDate = moment(this.fromDate).endOf("month").format("YYYY-MM-DD");
    let toDate = moment(this.toDate).endOf("month").format("YYYY-MM-DD");
    this.feesRepo
      .getManagementFeeParameters(
        fromDate,
        toDate,
        FeeCalculationStatus.NEW,
        this.selectedCurrency,
        feeCalculationType
      )
      .then((res) => {
        this.selectAll = false;
        this.clientFeeParameters = res.data as Array<any>;
        this.clientFeeParameters = this.clientFeeParameters.filter(
          (client) => client
        );

        this.clientFeeParameters.forEach((client) => {
          if (client) {
            client.isSelected = this.selectAll;
            client.portfolioFee.forEach((fee) => {
              fee.portfolios.forEach((portfolio) => {
                if (portfolio) {
                  portfolio.isSelected = this.selectAll;
                  if (portfolio.defaultCashAccountId < 0) {
                    this.setDefaultCashAccount(portfolio);
                  } else {
                    let defaultCashAccount = _.first(
                      _.filter(portfolio.cashAccountBalances, (cashBalance) => {
                        return (
                          cashBalance.cashItem.id ==
                          portfolio.defaultCashAccountId
                        );
                      })
                    );
                    // there could be a case that the default cash account set was not found - account closed or no latest balance for that cash account
                    // then we need to set the cash account again
                    if (defaultCashAccount) {
                      portfolio.defaultCurrency = defaultCashAccount.currency;
                      portfolio.selectedCashAccount = defaultCashAccount;
                    } else {
                      this.setDefaultCashAccount(portfolio);
                    }
                  }
                }
              });
            });
          }
        });
      })
      .catch((err) => {
        this.notifyjs("Failed to retrieve fee values " + err.data);
      })
      .finally(() => {
        this.setTotalNav();
        this.setTotalFeeValue();
        this.setTotalPortfolios();
        this.isLoadingParameters = false;
      });
  };

  selectAllClients = () => {
    this.clientFeeParameters.forEach((client) => {
      if (client) {
        client.isSelected = this.selectAll;
        client.portfolioFee.forEach((fee) => {
          fee.portfolios.forEach((portfolio) => {
            if (portfolio) {
              portfolio.isSelected = this.selectAll;
            }
          });
        });
      }
    });
  };

  getPercentageFromDecimal = (value) => {
    return +(value * 100).toFixed(2);
  };

  setDefaultCashAccount = (portfolio) => {
    let defaultCashAccount;
    if (this.displayMCB) {
      defaultCashAccount = _.first(
        _.filter(portfolio.cashAccountBalances, (cashBalance) => {
          return (
            cashBalance.currency == "MUR" &&
            cashBalance.portfolio.id == portfolio.portfolioId
          );
        })
      );
      // if you cannot find a cash account that belongs to the portfolio then pick a cash account that belongs to the client
      if (defaultCashAccount) {
        portfolio.defaultCashAccountId = defaultCashAccount.cashItem.id;
      } else {
        defaultCashAccount = _.first(
          _.filter(portfolio.cashAccountBalances, (cashBalance) => {
            return cashBalance.currency == "MUR";
          })
        );
      }
    } else if (!this.displayMCB) {
      defaultCashAccount = _.first(
        _.filter(portfolio.cashAccountBalances, (cashBalance) => {
          return (
            cashBalance.currency == "USD" &&
            cashBalance.portfolio.id == portfolio.portfolioId
          );
        })
      );
      // if you cannot find a cash account that belongs to the portfolio then pick a cash account that belongs to the client
      if (defaultCashAccount) {
        portfolio.defaultCashAccountId = defaultCashAccount.cashItem.id;
      } else {
        defaultCashAccount = _.first(
          _.filter(portfolio.cashAccountBalances, (cashBalance) => {
            return cashBalance.currency == "USD";
          })
        );
      }
    }

    if (defaultCashAccount) {
      portfolio.defaultCashAccountId = defaultCashAccount.cashItem.id;
      portfolio.defaultCurrency = defaultCashAccount.currency;
      portfolio.selectedCashAccount = defaultCashAccount;
    }
  };

  getPortfolioFeeNav = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      return _.first(
        _.filter(portfolio.feeParameters, (feeParam) => {
          return feeParam.currency == portfolio.defaultCurrency;
        })
      ).marketValue;
    }
  };

  getPortfolioFeeNavDelta = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      return _.first(
        _.filter(portfolio.feeParameters, (feeParam) => {
          return feeParam.currency == portfolio.defaultCurrency;
        })
      ).marketValueDelta;
    }
  };

  getPortfolioFeeNavMUR = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      return _.first(
        _.filter(portfolio.feeParameters, (feeParam) => {
          return feeParam.currency == "MUR";
        })
      ).marketValue;
    }
  };

  getPortfolioFeeExclusion = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      return _.first(
        _.filter(portfolio.feeParameters, (feeParam) => {
          return feeParam.currency == portfolio.defaultCurrency;
        })
      ).exclusionValue;
    }
  };

  getPortfolioFeeExclusionMUR = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      return _.first(
        _.filter(portfolio.feeParameters, (feeParam) => {
          return feeParam.currency == "MUR";
        })
      ).exclusionValue;
    }
  };

  getPortfolioFeeValue = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      return _.first(
        _.filter(portfolio.feeParameters, (feeParam) => {
          return feeParam.currency == portfolio.defaultCurrency;
        })
      ).feeValue;
    }
  };

  getPortfolioFeeValueDelta = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      return _.first(
        _.filter(portfolio.feeParameters, (feeParam) => {
          return feeParam.currency == portfolio.defaultCurrency;
        })
      ).feeValueDelta;
    }
  };

  getPortfolioFeeValueMUR = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      return _.first(
        _.filter(portfolio.feeParameters, (feeParam) => {
          return feeParam.currency == "MUR";
        })
      ).feeValue;
    }
  };

  displayFeeSummary = (client) => {
    client.displayFeeSummary = !client.displayFeeSummary;
  };

  selectAllClientPortfolios = (client) => {
    client.portfolioFee.forEach((fee) => {
      fee.portfolios.forEach((portfolio) => {
        if (portfolio) {
          portfolio.isSelected = client.isSelected;
        }
      });
    });
  };

  stopPropagation = ($event: angular.IAngularEvent) => {
    $event.stopPropagation();
  };

  selectPortfolio = (portfolio, client) => {
    if (!portfolio.isSelected) {
      client.isSelected = portfolio.isSelected;
    } else {
      let totalPortfolios = client.portfolioFee.reduce((acc, pf) => {
        return acc + pf.portfolios.length;
      }, 0);

      let totalPortfoliosSelected = client.portfolioFee.reduce((acc, pf) => {
        return acc + pf.portfolios.filter((p) => p.isSelected).length;
      }, 0);

      client.isSelected = totalPortfolios == totalPortfoliosSelected;
    }
  };

  getPortfolioSelectedText = (client) => {
    if (client) {
      let totalPortfoliosSelected = client.portfolioFee.reduce((acc, pf) => {
        return acc + pf.portfolios.filter((p) => p && p.isSelected).length;
      }, 0);

      let totalPortfolios = client.portfolioFee.reduce((acc, pf) => {
        return acc + pf.portfolios.length;
      }, 0);

      if (totalPortfolios == totalPortfoliosSelected) {
        return "All portfolio(s)";
      } else {
        return `${totalPortfoliosSelected} of ${totalPortfolios} portfolio(s) `;
      }
    }
  };

  updateFeeParameters = (portfolio) => {
    portfolio.defaultCashAccount = portfolio.selectedCashAccount.cashItem.id;
    portfolio.defaultCurrency = portfolio.selectedCashAccount.currency;
  };

  canSaveTempRun = () => {
    let totalPortfoliosSelected = 0;
    if (this.clientFeeParameters) {
      totalPortfoliosSelected = this.clientFeeParameters.reduce((a, client) => {
        if (client) {
          return (
            a +
            client.portfolioFee.reduce((acc, pf) => {
              return (
                acc + pf.portfolios.filter((p) => p && p.isSelected).length
              );
            }, 0)
          );
        }
      }, 0);
    }
    return totalPortfoliosSelected <= 0;
  };

  saveTempRun = () => {
    let feeCalculationType = this.displayMCB
      ? FeeCalculationType.MCB
      : FeeCalculationType.EDR;
    let tempRunParameters = [];
    this.clientFeeParameters.forEach((client) => {
      if (client) {
        client.portfolioFee.forEach((pf) => {
          pf.portfolios.forEach((p) => {
            if (p && p.isSelected) {
              tempRunParameters.push({
                clientId: client.id,
                portfolioId: p.portfolioId,
                portfolioFeeId: pf.portfolioFeeId,
                cashAccountId: p.selectedCashAccount.cashItem.id,
                currency: p.selectedCashAccount.currency,
                marketValue: this.getPortfolioFeeNav(p),
                marketValueMUR: this.getPortfolioFeeNavMUR(p),
                exclusionValue: this.getPortfolioFeeExclusion(p),
                exclusionValueMUR: this.getPortfolioFeeExclusionMUR(p),
                feeValue: this.getPortfolioFeeValue(p),
                feeValueMUR: this.getPortfolioFeeValueMUR(p),
                feeCalculationType: feeCalculationType,
                feeDate: client.feeDate,
              });
            }
          });
        });
      }
    });
    this.isSavingParameters = true;
    this.feesRepo
      .saveTempRunParameters(tempRunParameters)
      .then((res) => {
        this.getNewInstructionsParameters();
      })
      .catch((err) => {
        this.notifyjs("Failed to save temp run " + err.data);
      })
      .finally(() => (this.isSavingParameters = false));
  };

  formatDate(selectedDate) {
    return moment(selectedDate).endOf("month").format("YYYY-MM");
  }

  setTotalNav = () => {
    this.totalNav = this.clientFeeParameters.reduce((acc, client) => {
      if (client) {
        return acc + client.totalNAV;
      }
      return acc;
    }, 0);
  };

  getSelectedNav = () => {
    let selectedNav = 0;
    if (this.clientFeeParameters.length > 0) {
      selectedNav = this.clientFeeParameters.reduce((a, client) => {
        if (client) {
          return (
            a +
            client.portfolioFee.reduce((acc, pf) => {
              return (
                acc +
                pf.portfolios
                  .filter((p) => p && p.isSelected)
                  .reduce((a, p) => {
                    return (
                      a +
                      p.feeParameters.filter((fp) => fp.currency == "MUR")[0]
                        .marketValue
                    );
                  }, 0)
              );
            }, 0)
          );
        }
        return a;
      }, 0);
    }
    return selectedNav;
  };

  setTotalFeeValue = () => {
    this.totalFeeValue = this.clientFeeParameters.reduce((acc, client) => {
      if (client) {
        return acc + client.totalFeeValue;
      }
      return acc;
    }, 0);
  };

  getSelectedFeeValue = () => {
    let selectedFeeValue = 0;
    if (this.clientFeeParameters.length > 0) {
      selectedFeeValue = this.clientFeeParameters.reduce((a, client) => {
        if (client) {
          return (
            a +
            client.portfolioFee.reduce((acc, pf) => {
              return (
                acc +
                pf.portfolios
                  .filter((p) => p && p.isSelected)
                  .reduce((a, p) => {
                    return (
                      a +
                      p.feeParameters.filter((fp) => fp.currency == "MUR")[0]
                        .feeValue
                    );
                  }, 0)
              );
            }, 0)
          );
        }
        return a;
      }, 0);
    }
    return selectedFeeValue;
  };

  setTotalPortfolios = () => {
    this.totalPortfolios = this.clientFeeParameters.reduce((a, client) => {
      if (client) {
        return (
          a +
          client.portfolioFee.reduce((acc, pf) => {
            return acc + pf.portfolios.filter((p) => p).length;
          }, 0)
        );
      }
      return a;
    }, 0);
  };

  getSelectedPortfolios = () => {
    let selectedPortfolios = 0;
    if (this.clientFeeParameters.length > 0) {
      selectedPortfolios = this.clientFeeParameters.reduce((a, client) => {
        if (client) {
          return (
            a +
            client.portfolioFee.reduce((acc, pf) => {
              return (
                acc + pf.portfolios.filter((p) => p && p.isSelected).length
              );
            }, 0)
          );
        }
        return a;
      }, 0);
    }
    return selectedPortfolios;
  };

  getMidRateForMonth = () => {
    this.feesRepo
      .getMidRate(moment(this.midRateDate).endOf("month").format("YYYY-MM-DD"))
      .then((res) => {
        this.midRates = res.data as Array<any>;
      })
      .catch((err) => {
        this.notifyjs("Failed to get mid rates for selected month " + err.data);
      });
  };

  hasFeeValueAboveThreshold = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      let parameter = _.first(
        _.filter(portfolio.feeParameters, (feeParam) => {
          return feeParam.currency == portfolio.defaultCurrency;
        })
      );
      return (
        parameter.feeValueDelta * 100 > this.threshold ||
        parameter.feeValueDelta * 100 < -this.threshold
      );
    }
  };

  hasInSufficientFunds = (portfolio) => {
    if (portfolio && portfolio.defaultCurrency) {
      return portfolio.selectedCashAccount.marketValue <= 0;
    }
  };

  clientHasFeeValueAboveThreshold = (client) => {
    if (client) {
      return client.portfolioFee.some((pf) => {
        return pf.portfolios.some((p) => {
          return (
            p &&
            (this.hasFeeValueAboveThreshold(p) || this.hasInSufficientFunds(p))
          );
        });
      });
    }
  };

  getAllNewInstructionsParameters = () => {
    this.fromDate = moment("2019-01-31").format("YYYY-MM-DD");
    this.toDate = moment(this.currentDate)
      .subtract(1, "months")
      .endOf("month")
      .format("YYYY-MM-DD");
    this.getNewInstructionsParameters();
  };

  generateAdhocFeeInstructionSheet = () => {
    let feeCalculationType = this.displayMCB
      ? FeeCalculationType.MCB
      : FeeCalculationType.EDR;
    this.isLoadingParameters = true;
    let fromDate = moment(this.fromDate).endOf("month").format("YYYY-MM-DD");
    let toDate = moment(this.toDate).endOf("month").format("YYYY-MM-DD");

    this.feesRepo
      .generateAdhocTempRunSheet(fromDate, toDate, feeCalculationType)
      .then((res) => {
        let instructionExcel = res.data as any;
        this.$window.open(instructionExcel.url, "_blank");
      })
      .catch((err) => {
        this.notifyjs("Failed to generate ad-hoc instruction");
      })
      .finally(() => (this.isLoadingParameters = false));
  };

  recalculateFees = () => {
    let recalculateFees = this.clientFeeParameters
      .filter((client) => client.isSelected)
      .map((client) => {
        return {
          clientNumber: client.clientNumber,
          calculationDate: client.feeDate,
        };
      });
    this.feesRepo.recalculateFees(recalculateFees).then(() => {
      this.getNewInstructionsParameters();
    });
    console.log(recalculateFees);
  };
}

export const tempRun: angular.IComponentOptions = {
  template: require("./fees.instructions.temprun.html"),
  controller: TempRunController,
  bindings: {
    reloadTempParameters: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/fees/instructions/temprun/fees.instructions.temprun.ts